import React from "react";
import { Link, useParams } from "react-router-dom";
import Logo from "@/components/Logo";

const content = {
  terms: {
    title: "Terms of Service",
    body: [
      "Welcome to AIBoxHub. By accessing or using our services, you agree to these terms.",
      "All AIBoxHub products, including AI Queue Pro and the AI Marketplace, are provided 'as is' with industry-standard SLAs for paying plans.",
      "Subscriptions auto-renew unless cancelled. You may cancel at any time from your client dashboard.",
      "AIBoxHub reserves the right to update these terms; material changes will be communicated by email.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "We collect only the data necessary to deliver and improve our services. Your data is encrypted at rest and in transit.",
      "We do not sell personal data. Third-party AI providers process queries only to generate responses.",
      "You can request export or deletion of your account data at any time by contacting privacy@aiboxhub.com.",
    ],
  },
  refund: {
    title: "Refund Policy",
    body: [
      "Annual subscriptions are eligible for a pro-rated refund within 14 days of purchase.",
      "Monthly subscriptions can be cancelled at any time; the current cycle remains active until its end.",
      "Custom development engagements are governed by separate signed agreements.",
    ],
  },
  docs: {
    title: "Documentation",
    body: [
      "Full developer documentation is in active production. In the meantime, our concierge team will assist with onboarding.",
      "API: REST + JSON, hosted at /api with JWT-based auth. Webhooks coming soon.",
      "SDKs planned for JavaScript, Python and Go.",
    ],
  },
  careers: {
    title: "Careers at AIBoxHub",
    body: [
      "We are a small, senior team building category-defining AI products. Roles open for Senior Engineers, Designers and Solution Architects.",
      "Hybrid-remote across Dubai, London and Bangalore. Generous equity for early team members.",
      "Send a brief intro and links to your work: careers@aiboxhub.com",
    ],
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = content[slug] || { title: "Page Not Found", body: ["This page does not exist."] };

  return (
    <div className="min-h-screen container-px py-24" data-testid={`legal-${slug}`}>
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="inline-flex mb-10"><Logo /></Link>
        <div className="eyebrow text-gold-300">Legal & Resources</div>
        <h1 className="mt-2 font-serif text-4xl md:text-5xl text-white">{page.title}</h1>
        <div className="mt-8 space-y-5 text-white/70 leading-relaxed">
          {page.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </div>
    </div>
  );
}
